// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_substitution = require("./MM_substitution.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

function iterateCombinationsRec(candidatesPerHyp, comb, hypIdx, skipCombinationsWithEmptyArgs, skipCombinationsWithoutEmptyArgs, combinationConsumer) {
  if (hypIdx === comb.length) {
    var thereIsEmptyArg = comb.some(function (a) {
          return a === -1;
        });
    if (thereIsEmptyArg) {
      if (skipCombinationsWithEmptyArgs) {
        return /* Continue */0;
      } else {
        return Curry._1(combinationConsumer, comb);
      }
    } else if (skipCombinationsWithoutEmptyArgs) {
      return /* Continue */0;
    } else {
      return Curry._1(combinationConsumer, comb);
    }
  }
  var res = /* Continue */0;
  var c = 0;
  var maxC = Caml_array.get(candidatesPerHyp, hypIdx).length - 1 | 0;
  while(res === /* Continue */0 && c <= maxC) {
    Caml_array.set(comb, hypIdx, Caml_array.get(Caml_array.get(candidatesPerHyp, hypIdx), c));
    if (!(Caml_array.get(comb, hypIdx) === -1 && skipCombinationsWithEmptyArgs)) {
      res = iterateCombinationsRec(candidatesPerHyp, comb, hypIdx + 1 | 0, skipCombinationsWithEmptyArgs, skipCombinationsWithoutEmptyArgs, combinationConsumer);
    }
    c = c + 1 | 0;
  };
  return res;
}

function iterateCombinations(numOfStmts, numOfHyps, stmtCanMatchHyp, combinationConsumer) {
  var candidatesPerHyp = Belt_Array.makeBy(numOfHyps, (function (param) {
          return [];
        }));
  var maxH = numOfHyps - 1 | 0;
  var maxS = numOfStmts - 1 | 0;
  for(var h = 0; h <= maxH; ++h){
    for(var s = -1; s <= maxS; ++s){
      if (Curry._2(stmtCanMatchHyp, s, h)) {
        Caml_array.get(candidatesPerHyp, h).push(s);
      }
      
    }
  }
  var thereIsHypWithoutAnyCandidate = candidatesPerHyp.some(function (candidates) {
        return candidates.length === 0;
      });
  if (thereIsHypWithoutAnyCandidate) {
    return /* Continue */0;
  }
  var comb = Belt_Array.make(numOfHyps, 0);
  var $$continue = iterateCombinationsRec(candidatesPerHyp, comb, 0, true, false, combinationConsumer);
  if ($$continue === /* Continue */0) {
    return iterateCombinationsRec(candidatesPerHyp, comb, 0, false, true, combinationConsumer);
  } else {
    return $$continue;
  }
}

function iterateSubstitutionsWithWorkVars(workVars, frm, hypIdx, $$continue) {
  var initialNumOfWorkVars = workVars.newVars.length;
  var predefinedSubs = frm.subs.isDefined.slice();
  var nextVar = {
    contents: (workVars.maxVar + 1 | 0) + workVars.newVars.length | 0
  };
  var frmVars = [];
  var newVars = [];
  var newVarTypes = [];
  var newExprWithWorkVars = MM_substitution.applySubs(hypIdx < frm.hypsE.length ? Caml_array.get(frm.hypsE, hypIdx).expr : frm.frame.asrt, frm.subs, (function (frmVar) {
          var idx = frmVars.indexOf(frmVar);
          if (idx !== -1) {
            return Caml_array.get(newVars, idx);
          }
          var newVar = nextVar.contents;
          nextVar.contents = nextVar.contents + 1 | 0;
          frmVars.push(frmVar);
          newVars.push(newVar);
          newVarTypes.push(Caml_array.get(frm.frame.varTypes, frmVar));
          return newVar;
        }));
  var maxI = frmVars.length - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var frmVar = Caml_array.get(frmVars, i);
    var newVar = Caml_array.get(newVars, i);
    var newVarType = Caml_array.get(newVarTypes, i);
    Caml_array.set(frm.subs.exprs, frmVar, [newVar]);
    Caml_array.set(frm.subs.begins, frmVar, 0);
    Caml_array.set(frm.subs.ends, frmVar, 0);
    Caml_array.set(frm.subs.isDefined, frmVar, true);
    workVars.newVars.push(newVar);
    workVars.newVarTypes.push(newVarType);
  }
  Caml_array.set(workVars.hypIdxToExprWithWorkVars, hypIdx, newExprWithWorkVars);
  var res = Curry._1($$continue, undefined);
  predefinedSubs.forEach(function (predefined, i) {
        Caml_array.set(frm.subs.isDefined, i, predefined);
      });
  workVars.newVars.splice(initialNumOfWorkVars);
  workVars.newVarTypes.splice(initialNumOfWorkVars);
  Caml_array.set(workVars.hypIdxToExprWithWorkVars, hypIdx, undefined);
  return res;
}

function iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, comb, hypIdx, onMatchFound) {
  if (hypIdx === comb.length) {
    return iterateSubstitutionsWithWorkVars(workVars, frm, hypIdx, onMatchFound);
  } else if (Caml_array.get(comb, hypIdx) >= 0) {
    return MM_substitution.iterateSubstitutions(Caml_array.get(frm.hypsE, hypIdx).expr, Caml_array.get(statements, Caml_array.get(comb, hypIdx)), Caml_array.get(frm.frmConstParts, hypIdx), Caml_array.get(frm.constParts, hypIdx), Caml_array.get(frm.varGroups, hypIdx), frm.subs, parenCnt, (function (param) {
                  return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, comb, hypIdx + 1 | 0, onMatchFound);
                }));
  } else {
    return iterateSubstitutionsWithWorkVars(workVars, frm, hypIdx, (function (param) {
                  return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, comb, hypIdx + 1 | 0, onMatchFound);
                }));
  }
}

function extractNewDisj(frmDisj, subs, maxCtxVar, isDisjInCtx) {
  var result = MM_context.disjMutableMake(undefined);
  var disjIsValid = MM_substitution.verifyDisjoints(frmDisj, subs, (function (n, m) {
          if (n <= maxCtxVar && m <= maxCtxVar) {
            return Curry._2(isDisjInCtx, n, m);
          } else {
            MM_context.disjAddPair(result, n, m);
            return true;
          }
        }));
  if (disjIsValid) {
    return Caml_option.some(result);
  }
  
}

function iterateSubstitutionsForResult(frm, result, parenCnt, consumer) {
  if (result !== undefined) {
    return MM_substitution.iterateSubstitutions(frm.frame.asrt, result, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, parenCnt, consumer);
  } else {
    return Curry._1(consumer, frm.subs);
  }
}

function applyAssertions(maxVar, frms, isDisjInCtx, statements, exactOrderOfStmtsOpt, allowEmptyArgsOpt, result, parenCnt, frameFilterOpt, onMatchFound, onProgress, param) {
  var exactOrderOfStmts = exactOrderOfStmtsOpt !== undefined ? exactOrderOfStmtsOpt : false;
  var allowEmptyArgs = allowEmptyArgsOpt !== undefined ? allowEmptyArgsOpt : true;
  var frameFilter = frameFilterOpt !== undefined ? frameFilterOpt : (function (param) {
        return true;
      });
  var numOfStmts = statements.length;
  var numOfFrames = Belt_MapString.size(frms);
  var progressState = {
    contents: MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined, undefined)
  };
  var framesProcessed = {
    contents: 0
  };
  Belt_MapString.forEach(frms, (function (param, frm) {
          if (Curry._1(frameFilter, frm.frame) && Belt_Option.getWithDefault(Belt_Option.map(result, (function (result) {
                        return Caml_array.get(result, 0) === Caml_array.get(frm.frame.asrt, 0);
                      })), true)) {
            iterateSubstitutionsForResult(frm, result, parenCnt, (function (param) {
                    var numOfHyps = frm.numOfHypsE;
                    var workVars_newVars = [];
                    var workVars_newVarTypes = [];
                    var workVars_hypIdxToExprWithWorkVars = Belt_Array.make(numOfHyps + 1 | 0, undefined);
                    var workVars = {
                      maxVar: maxVar,
                      newVars: workVars_newVars,
                      newVarTypes: workVars_newVarTypes,
                      hypIdxToExprWithWorkVars: workVars_hypIdxToExprWithWorkVars
                    };
                    return iterateCombinations(numOfStmts, numOfHyps, (function (s, h) {
                                  if (s === -1) {
                                    if (exactOrderOfStmts) {
                                      return false;
                                    } else {
                                      return allowEmptyArgs;
                                    }
                                  } else if (!exactOrderOfStmts || s === h) {
                                    var stmt = Caml_array.get(statements, s);
                                    var hyp = Caml_array.get(frm.hypsE, h).expr;
                                    if (Caml_array.get(hyp, 0) !== Caml_array.get(stmt, 0)) {
                                      return false;
                                    }
                                    var res = {
                                      contents: false
                                    };
                                    MM_substitution.iterateSubstitutions(hyp, stmt, Caml_array.get(frm.frmConstParts, h), Caml_array.get(frm.constParts, h), Caml_array.get(frm.varGroups, h), frm.subs, parenCnt, (function (param) {
                                            res.contents = true;
                                            return /* Stop */1;
                                          }));
                                    return res.contents;
                                  } else {
                                    return false;
                                  }
                                }), (function (comb) {
                                  return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, comb, 0, (function (param) {
                                                var newDisj = extractNewDisj(frm.frame.disj, frm.subs, maxVar, isDisjInCtx);
                                                if (newDisj !== undefined) {
                                                  return Curry._1(onMatchFound, {
                                                              newVars: workVars_newVars.slice(),
                                                              newVarTypes: workVars_newVarTypes.slice(),
                                                              newDisj: Caml_option.valFromOption(newDisj),
                                                              asrtLabel: frm.frame.label,
                                                              subs: {
                                                                size: frm.subs.size,
                                                                begins: frm.subs.begins.slice(),
                                                                ends: frm.subs.ends.slice(),
                                                                exprs: frm.subs.exprs.slice(),
                                                                isDefined: frm.subs.isDefined.slice()
                                                              }
                                                            });
                                                } else {
                                                  return /* Continue */0;
                                                }
                                              }));
                                }));
                  }));
          }
          framesProcessed.contents = framesProcessed.contents + 1;
          progressState.contents = MM_progress_tracker.progressTrackerSetCurrPct(progressState.contents, framesProcessed.contents / numOfFrames);
        }));
}

exports.applyAssertions = applyAssertions;
exports.iterateCombinations = iterateCombinations;
/* MM_context Not a pure module */
